import React from "react";
import { Wrapper } from "./CloserLeaderBoard.styled";
import { Col, Row, Spin, Select_ } from "components/common";
import SampleImage from "../../../assets/svg/user.svg";
import CloserBoardEntity from "./CloserBoardEntity/CloserBoardEntity";
import { useEffect } from "react";
import { useState } from "react";
import { callGetApi, callPostApi } from "utils/api";
import moment from "moment/moment.js";

const CloserLeaderBoard = () => {
  const [setterLead, setSetterLead] = useState([]);
  const [filterSetter, setFilterSetter] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [location, setLocation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateData, setDateData] = useState({});
  const [filterLoad, setFilterLoad] = useState(false);

  let data = [
    { name: "All " },
    { name: "This Week" },
    { name: "Last Week" },
    { name: "This Month" },
    { name: "Last Month" },
  ];

  const getSetterApi = () => {
    setIsLoading(true);
    callPostApi(
      "/reports/leaderboard/rep/closer",
      onSuccessSetterApi,
      onFailedSetterApi
    );
    callGetApi("/location", onSuccessGetLocation, onFailGetLocation);
  };
  const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] > b[property] ? -1 : a[property] < b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };
  const SuccessDateCall = (data) => {
    if (locationId === "") {
      setSetterLead(data);
      setFilterSetter(data);
    } else if (locationId) {
      let filterArray = [];
      data?.map((setter) => {
        if (setter?.locationId == locationId) {
          filterArray?.push(setter);
        }
      });
      setSetterLead(data);
      setFilterSetter(filterArray);
    }
    setFilterLoad(false);
  };

  const FailDateCall = (err) => {
    console.log(err);
    setFilterLoad(false);
  };
  const onSuccessGetLocation = (data) => {
    setLocation(data);
    // setLocationId(data?.[0]?.id);
  };

  const onFailGetLocation = (err) => {
    console.log(err);
  };

  const onSuccessSetterApi = (data) => {
    setFilterSetter(data);
    let a = data;
    a.sort(dynamicSort("totalRepLeads"));
    setSetterLead(data);
    setIsLoading(false);
    setFilterLoad(false);
  };

  const onFailedSetterApi = (err) => {
    setIsLoading(false);
    console.log(err);
    setFilterLoad(false);
  };

  const handleChange = (e) => {
    if (e === "1") {
      setDateData({
        startDate: moment().startOf("week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      });
    } else if (e === "2") {
      setDateData({
        startDate: moment()
          .startOf("week")
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        endDate: moment()
          .endOf("week")
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
      });
    } else if (e === "3") {
      setDateData({
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      });
    } else if (e === "4") {
      setDateData({
        startDate: moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD"),

        endDate: moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD"),
      });
    } else {
      setDateData("");
    }
  };

  useEffect(() => {
    if (dateData) {
      callPostApi("/reports/leaderboard/rep/closer", dateData, SuccessDateCall, FailDateCall);
    }
    setFilterLoad(true);
  }, [dateData]);

  useEffect(() => {
    getSetterApi();
  }, []);

  useEffect(() => {
    if (locationId === "") {
      setFilterSetter(setterLead);
    } else if (locationId) {
      let filterArray = [];
      setterLead?.map((setter) => {
        if (setter?.locationId == locationId) {
          filterArray.push(setter);
        }
      });
      setFilterSetter(filterArray);
    }
  }, [locationId, setterLead, location]);

  let address0 = location?.filter(
    (el) => el?._id.toString() === filterSetter?.[0]?.locationId
  );
  let address1 = location?.filter(
    (el) => el?._id.toString() === filterSetter?.[1]?.locationId
  );
  let address2 = location?.filter(
    (el) => el?._id.toString() === filterSetter?.[2]?.locationId
  );

  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <div>
          <Row gutter={[15, 10]}>
            <Col xs={24} sm={24} lg={24} xl={12} xxl={12}>
              <h3 style={{ fontSize: "14px", margin: 0 }}>Location</h3>
              <div className="filter-container">
                {" "}
                <Select_
                  defaultValue="All"
                  options={[
                    { name: "All ", id: "" },
                    ...location?.map((el) => el),
                  ]}
                  name
                  value={locationId}
                  onChange={(value) => {
                    setLocationId(value);
                  }}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} lg={24} xl={12} xxl={12}>
              <h3 style={{ fontSize: "14px", margin: 0 }}>Time</h3>
              <div className="filter-container">
                {" "}
                <Select_
                  options={data}
                  name
                  defaultValue="All "
                  onChange={handleChange}
                />
              </div>
            </Col>
          </Row>

          {filterLoad ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <Spin />
            </div>
          ) : (
            <>
              <div className="leaderboard-container">
                <div>
                  {filterSetter?.length > 0 && (
                    <div className="position-holders">
                      {filterSetter?.[1] && (
                        <div className="position-holder-numbers">
                          <div>
                            <img
                              src={filterSetter?.[1].profilePicture ? filterSetter?.[1].profilePicture : SampleImage}
                              alt=""
                              className="_2nd-position-holder"
                            />
                          </div>
                          <div className="holder-two">2</div>
                          <div className="ranker-name">
                            <div>
                              <h4>{filterSetter?.[1]?.username}</h4>
                            </div>
                            <div>
                              <h5>
                                {address1?.[0]?.name}, {address1?.[0]?.state}
                              </h5>
                            </div>
                            <div>
                              <h3 className="sales-color">
                                {filterSetter?.[1]?.totalRepLeads} Sales
                              </h3>
                              <h6 style={{ color: "#5ec9f4" }}>{filterSetter?.[1]?.totalRepProjectKw} Kw</h6>
                            </div>
                          </div>
                        </div>
                      )}
                      {filterSetter?.[0] && (
                        <div className="position-holder-numbers">
                          <div>
                            <img
                              src={filterSetter?.[0].profilePicture ? filterSetter?.[0].profilePicture : SampleImage}
                              alt=""
                              className="_1nd-position-holder"
                            />
                          </div>

                          <div className="holder-one">1</div>
                          <div className="ranker-name">
                            <div>
                              <h4>{filterSetter?.[0]?.username}</h4>
                            </div>
                            <div>
                              <h5>
                                {address0?.[0]?.name}, {address0?.[0]?.state}
                              </h5>
                            </div>
                            <div>
                              <h3 className="sales-gold">
                                {filterSetter?.[0]?.totalRepLeads} Sales
                              </h3>
                            </div>
                            <div className="sale">
                              <p>{filterSetter?.[0]?.totalRepProjectKw} Kw</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {filterSetter?.[2] && (
                        <div className="position-holder-numbers">
                          <div>
                            <img
                              src={filterSetter?.[2].profilePicture ? filterSetter?.[2].profilePicture : SampleImage}
                              alt=""
                              className="_2nd-position-holder"
                            />
                          </div>
                          <div className="holder-two">3</div>
                          <div className="ranker-name">
                            <div>
                              <h4>{filterSetter?.[2]?.username}</h4>
                            </div>
                            <div>
                              <h5>
                                {address2?.[0]?.name}, {address2?.[0]?.state}
                              </h5>
                            </div>
                            <div>
                              <h3 className="sales-color">
                                {filterSetter?.[2]?.totalRepLeads} Sales
                              </h3>
                            </div>
                            <div>
                              <h6 style={{ color: "#5ec9f4" }}>{filterSetter?.[2]?.totalRepProjectKw} Kw</h6>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="border-line"></div>
                {filterSetter.length > 3 && (
                  <div className="seller-tags">
                    <Row className="headings">
                      <Col className="rank-title" xs={5} sm={5} md={5} lg={6}>
                        <h5>Rank</h5>
                      </Col>
                      <Col className="rank-title" xs={9} sm={9} md={9} lg={8}>
                        <h5>Rep</h5>
                      </Col>
                      <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
                        <h5>Sales</h5>
                      </Col>
                      <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
                        <h5>KW</h5>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>

              {filterSetter.length > 3 && filterSetter?.slice(3).map((item, index) => {
                return (
                  <CloserBoardEntity
                    data={item}
                    location={location}
                    rank={index + 4}
                  />
                );
              })}
            </>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default CloserLeaderBoard;
